import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { agent } from "../../../utils/agent";
import * as API from "../../../utils/apiPath";

// 1) LOAD COMMUNITY DETAIL
export const loadCommunityDetail = createAsyncThunk(
  "community/detail",
  async (slug, { rejectWithValue }) => {
    try {
      const res = await agent.get(API.CMS_PAGE + slug);
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// 2) LOAD LEADERS
export const loadLeaders = createAsyncThunk(
  "community/leaders",
  async (limit, { rejectWithValue }) => {
    try {
      const res = await agent.get(API.LEADER_DATA, {
        params: { limit }
      });
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// 3) LOAD COMMUNITY LIST
export const loadCommunityList = createAsyncThunk(
  "community/list",
  async (limit, { rejectWithValue }) => {
    try {
      const res = await agent.get(API.COMMUNITY_DATA, {
        params: { limit }
      });
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// 4) JOIN A GROUP
export const joinGroup = createAsyncThunk(
  "community/joinGroup",
  async ({ community_id, user_id }, { rejectWithValue }) => {
    try {
      const res = await agent.get(`${API.LOAD_COMMUNITY}/joinGroup/${community_id}/${user_id}`);
      return res.data.message;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// 5) EXIT A GROUP
export const exitGroup = createAsyncThunk(
  "community/exitGroup",
  async ({ community_id, user_id }, { rejectWithValue }) => {
    try {
      const res = await agent.get(`${API.LOAD_COMMUNITY}/exitGroup/${community_id}/${user_id}`);
      return res.data.message;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const communityDetailSlice = createSlice({
  name: "communityDetail",
  initialState: {
    communityDetail: {},
    leaders: [],
    communityList: [],
    loading: false,
    error: null,
  },

  reducers: {},

  extraReducers: (builder) => {
    builder
      // --- LOAD DETAIL ---
      .addCase(loadCommunityDetail.pending, (state) => {
        state.loading = true;
      })
      .addCase(loadCommunityDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.communityDetail = action.payload;
      })
      .addCase(loadCommunityDetail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // --- LEADERS ---
      .addCase(loadLeaders.fulfilled, (state, action) => {
        state.leaders = action.payload;
      })

      // --- COMMUNITY LIST ---
      .addCase(loadCommunityList.fulfilled, (state, action) => {
        state.communityList = action.payload;
      })

      // --- JOIN GROUP ---
      .addCase(joinGroup.fulfilled, (state, action) => {
        // optional: update local state
      })

      // --- EXIT GROUP ---
      .addCase(exitGroup.fulfilled, (state, action) => {
        // optional: update local state
      });
  }
});

export default communityDetailSlice.reducer;
